import { Component, Input, OnInit } from '@angular/core';
import { Components, Files } from "../../../../_shared/interfaces";
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule} from "@clr/angular";
import { AlertService, FileStoreService, IAlertType } from "../../../../_shared/services";
import { ActivatedRoute } from "@angular/router";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";
import { saveAs } from "file-saver";
import { environment as env } from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import { NgForOf, NgIf } from "@angular/common";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {UploadComponent} from "../../../../core/upload/upload.component";

@Component({
  selector: 'app-invoice-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgForOf,
    NgIf,
    ClrIconModule,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    UploadComponent
  ],
  templateUrl: './invoice-details-documents.component.html',
  styleUrl: './invoice-details-documents.component.sass'
})
export class InvoiceDetailsDocumentsComponent implements OnInit {
  components: Components[] = [];
  invoiceFiles: Files[] = [];
  public showPdf = false;
  public showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;

  private filesDirectory = filesBaseUrl();


  constructor(
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([3], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([3], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, this.jobId, 0).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.invoiceFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.invoiceFiles = data.object;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.invoiceFiles = this.invoiceFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([3], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
